// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multi-selector-container[data-v-f19b1036]{width:100%;overflow-x:auto;position:relative}.multi-slider[data-v-f19b1036]{display:flex;gap:8px;padding:8px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
